import { render, staticRenderFns } from "./forumPosts.vue?vue&type=template&id=a831e38e&scoped=true"
import script from "./forumPosts.vue?vue&type=script&lang=js"
export * from "./forumPosts.vue?vue&type=script&lang=js"
import style0 from "./forumPosts.vue?vue&type=style&index=0&id=a831e38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a831e38e",
  null
  
)

export default component.exports